export enum AssistantType {
  allMetadataAndDependencies = 'allMetadataAndDependencies',
  permissions = 'permissions'
}

export const AssistantLabels: {[key in AssistantType]: string} = {
  [AssistantType.allMetadataAndDependencies]: 'Metadata and dependencies',
  [AssistantType.permissions]: 'Permissions'
};

export type Assistants = Array<{
  label: string;
  type: AssistantType;
}>;
